import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

type Props = {
	id: string;
	email: string | null | undefined;
	emailHref: string;
	trackEmailDmClick: (id: string) => void;
};

export const EmailDm: React.FC<Props> = ({ id, email, emailHref, trackEmailDmClick }) => {
	const { translate } = useI18n();

	return email ? (
		<div className="ml-auto flex flex-row items-center">
			<Button
				as="a"
				data-testid="email-dm"
				data-qa="email-dm"
				onClick={() => trackEmailDmClick(id)}
				href={emailHref}
				target="_blank"
				variant="secondary"
				size="x-small"
			>
				{translate('corgi.petition.starter_dashboard_v2.decision_makers.cards.send_email')}
			</Button>
		</div>
	) : null;
};
